import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { Div } from 'legacyComponents/styled/lib';

import { AddSeatsForm } from 'apps/payment/subscription/addSeatsForm';
import { RemoveSeatsForm } from 'apps/payment/subscription/removeSeatsForm';

import { AddPaymentMethodLink as SeatsLink } from 'apps/payment/styles';

@withNamespaces()
@observer
export class EditSeats extends React.Component {
  render() {
    const { paymentSpace, paymentSpacePreview } = this.props;
    if (!paymentSpace) return null;
    const { subscription } = paymentSpace;
    if (!subscription) return null;
    const { seats } = subscription;

    return (
      <Div width='50%'>
        {seats.canBeAdded && seats.formVisible !== 'add' ? (
          <SeatsLink onClick={() => seats.SetFormVisibility('add')}>
            + <Trans>Add Seats</Trans>
          </SeatsLink>
        ) : null}
        {seats.formVisible === 'add' ? (
          <AddSeatsForm
            paymentSpace={paymentSpace}
            paymentSpacePreview={paymentSpacePreview}
          />
        ) : null}
        {seats.canBeRemoved && seats.formVisible !== 'remove' ? (
          <SeatsLink danger onClick={() => seats.SetFormVisibility('remove')}>
            - <Trans>Remove Seats</Trans>
          </SeatsLink>
        ) : null}
        {seats.formVisible === 'remove' ? (
          <RemoveSeatsForm
            paymentSpace={paymentSpace}
            paymentSpacePreview={paymentSpacePreview}
          />
        ) : null}
      </Div>
    );
  }
}

EditSeats.propTypes = {
  paymentSpace: PropTypes.object,
  paymentSpacePreview: PropTypes.object,
};
